// import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import { Box, Chip, Paper } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import Flex from "../../../../components/Flex";
import OutlineCard from "../../../../components/OutlineCard";
import Text from "../../../../components/Text";
import PaymentDrawer from "../../../../components/app/provider/billing/payment/PaymentDrawer";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useStripeGetAllCard } from "../../../../queries/stripe/use-get-all-stripe-card";
import { getStripePromise } from "../../../../queries/stripe/use-stripe";
import { useGetPatientPaymentSummary } from "../../../../queries/billings/payments/use-get-patient-payment-summary";
import { GetPatientAllPaymentTypeOfPaymentEnum } from "../../../../services";
import { getPaymentModeLabel } from "./payments/patient-payments-constant";
// import { useGetPaymentsDue } from "../../../../queries/billings/use-get-payments-due";
import {
  NonNullableDate,
  // formatDate,
} from "../../../../utils/date-time-utility";
import {
  DEFAULT_FONTSIZE,
  SECONDARY_TEXT_COLOR,
  // getFormattedId,
  getXtenantId,
} from "../../../../utils/utils";
import PatientDetailsSideSectionForClaim, {
  RenderingProviderInfo,
} from "./claims/updateClaims/PatientDetailsSideSectionForClaim";

interface PatientDetailsSideSectionProps {
  patientsData?: any;
  viewBill?: boolean;
  total?: number;
  providerId?: { uuid: string; name: string };
  renderingProviderInfo?: RenderingProviderInfo;
  // Visit/encounter id, retained for the (currently disabled) Outstanding
  // Balance breakdown. Payment History itself is patient-wide, not per-visit.
  visitId?: string;
}

const PatientDetailsSideSection = ({
  patientsData,
  viewBill = true,
  total,
  providerId,
  renderingProviderInfo,
  visitId,
}: PatientDetailsSideSectionProps) => {
  const payDisc = useDisclosure();

  // Payment History lists only what the patient has paid. Insurance (ERA)
  // payments share the same endpoint, so they are filtered out at the API with
  // typeOfPayment=PATIENT rather than on the client.
  const { data: cards } = useStripeGetAllCard({
    patientUuid: patientsData?.uuid,
    typeOfPayment: GetPatientAllPaymentTypeOfPaymentEnum.Patient,
    xTENANTID: getXtenantId(),
  });

  // Payment History is patient-wide (all payments received across every visit),
  // so its total comes from the patient-scoped by-visit summary call — not the
  // per-visit one, which is gated on a visitId that Edit Invoice may not carry.
  const { data: paymentSummary } = useGetPatientPaymentSummary({
    patientUuid: patientsData?.uuid,
    enabled: !!patientsData?.uuid,
  });
  const totalPaymentReceived = paymentSummary?.data?.totalPaymentReceived ?? 0;

  // Per-invoice breakdown of unpaid / partially paid invoices (AC 3).
  // const { data: paymentsDue }: any = useGetPaymentsDue({
  //   patientUuid: patientsData?.uuid,
  // });
  // const outstandingRows: any[] = paymentsDue?.data?.content ?? [];

  const paymentHistoryRows = cards?.data?.content ?? [];

  return (
    <>
      <Flex flexDirection={"column"}>
        <PatientDetailsSideSectionForClaim
          patientsData={patientsData}
          hideInsuranceInfo={true}
          renderingProviderInfo={renderingProviderInfo}
          appointmentUuid={visitId}
        />
      </Flex>

      {/* <Flex flexDirection={"column"} width={"100%"} mt={1}>
        <OutlineCard sx={{ backgroundColor: "primary.light" }}>
          <Text
            fontWeight={"bold"}
            variant="h6"
            fontSize={"12px"}
            color={SECONDARY_TEXT_COLOR}
            alignSelf={"center"}
            margin={"5px 0px"}
          >
            {`Outstanding Balance ($${Number(previousBalance).toFixed(
              2
            )} total)`}
          </Text>
          <Paper
            sx={{
              width: "100%",
              maxHeight: "210px",
              overflow: "auto",
              backgroundColor: "primary.light",
              boxShadow: "none",
            }}
          >
            {outstandingRows.length === 0 ? (
              <Text
                fontSize={DEFAULT_FONTSIZE}
                color={SECONDARY_TEXT_COLOR}
                alignSelf={"center"}
                textAlign={"center"}
                margin={"10px 0px"}
              >
                No outstanding balance
              </Text>
            ) : (
              outstandingRows.map((row, idx) => {
                const visitIdValue = row?.encounterId ?? row?.appointmentUuid;
                const dosValue =
                  row?.encounterDate ??
                  row?.appointmentDate ??
                  row?.dateOfService;
                return (
                  <OutlineCard
                    key={row?.superBillUuid ?? idx}
                    style={{ paddingBlock: "12px", width: "100%" }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "5px",
                      marginTop: "8px",
                    }}
                  >
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"center"}
                    >
                      <Text
                        fontWeight={"bold"}
                        variant="h6"
                        fontSize={DEFAULT_FONTSIZE}
                        color={"secondary.main"}
                      >
                        {`Invoice #${
                          row?.superBillUuid
                            ? getFormattedId(row.superBillUuid)
                            : "-"
                        }`}
                      </Text>
                      <Text
                        fontSize={DEFAULT_FONTSIZE}
                        color={SECONDARY_TEXT_COLOR}
                      >
                        {`Visit ${
                          visitIdValue ? getFormattedId(visitIdValue) : "-"
                        }`}
                      </Text>
                    </Flex>
                    <Text
                      fontSize={DEFAULT_FONTSIZE}
                      color={SECONDARY_TEXT_COLOR}
                    >
                      {dosValue ? formatDate(dosValue) : "-"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={DEFAULT_FONTSIZE}>
                      {`Amount Owed: $${Number(row?.amountDue ?? 0).toFixed(2)}`}
                    </Text>
                  </OutlineCard>
                );
              })
            )}
          </Paper>
        </OutlineCard>
      </Flex> */}

      <Flex marginTop={"auto"} flexDirection={"column"} width={"100%"} mt={1}>
        <Flex flexDirection={"column"} height={"100%"} gap={1}>
          <OutlineCard sx={{ backgroundColor: "primary.light" }}>
            {viewBill && (
              <Flex alignItems={"center"} gap={2} width={"100%"}>
                <Text fontWeight={"bold"} variant="h6" color={"primary.main"}>
                  Payment Amount:
                </Text>
                <Text
                  fontWeight={"bold"}
                  variant="h6"
                  fontSize={"18px"}
                  color={"secondary.main"}
                >
                  ${total?.toString() ?? "0"}
                </Text>
              </Flex>
            )}

            <Elements stripe={getStripePromise()}>
              <PaymentDrawer
                disclosureHost={payDisc}
                amount={total?.toString() ?? "0"}
                shouldPassPatientId
                providerId={providerId}
              />
            </Elements>

            <Text
              fontWeight={"bold"}
              variant="h6"
              fontSize={"12px"}
              color={SECONDARY_TEXT_COLOR}
              alignSelf={"center"}
              margin={"5px 0px"}
            >
              {`Payment History ($${Number(totalPaymentReceived).toFixed(
                2
              )} received)`}
            </Text>
            <Paper
              sx={{
                width: "100%",
                height: "210px",
                overflow: "auto",
                backgroundColor: "primary.light",
                boxShadow: "none",
              }}
            >
              {/* install thin line scrollbar */}
              {paymentHistoryRows.length === 0 && (
                <Text
                  fontSize={DEFAULT_FONTSIZE}
                  color={SECONDARY_TEXT_COLOR}
                  alignSelf={"center"}
                  textAlign={"center"}
                  margin={"10px 0px"}
                >
                  No payment history
                </Text>
              )}
              {paymentHistoryRows.map((it, idx) => {
                return (
                  <OutlineCard
                    key={idx}
                    style={{
                      height: "30%",
                      paddingBlock: "15px",
                      width: "100%",
                    }}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "5px",
                      marginTop: "8px",
                    }}
                  >
                    <Flex
                      height={"25px"}
                      gap={0.5}
                      justifyContent={"flex-start"}
                      alignItems={"stretch"}
                    >
                      <Box width={"25%"}>
                        <Chip
                          size="small"
                          label={getPaymentModeLabel(it?.paymentMode)}
                          variant="filled"
                          sx={{
                            color: "secondary.main",
                            padding: "1px 5px",
                            background: "#e5f4fd",
                            fontSize: DEFAULT_FONTSIZE,
                          }}
                        />
                      </Box>
                      <Text
                        fontWeight={"bold"}
                        variant="h6"
                        fontSize={DEFAULT_FONTSIZE}
                        alignSelf={"center"}
                        marginLeft={"8px"}
                      >
                        {it?.amount}
                      </Text>
                    </Flex>
                    <Flex
                      height={"25px"}
                      justifyContent={"flex-start"}
                      alignItems={"stretch"}
                    >
                      <Text
                        width={"30%"}
                        fontWeight={"small"}
                        variant="h6"
                        fontSize={DEFAULT_FONTSIZE}
                        alignSelf={"center"}
                        borderRight={"1px solid lightgray"}
                      >
                        {NonNullableDate(it?.paymentDate)}
                      </Text>
                      <Text
                        width={"60%"}
                        fontWeight={"small"}
                        variant="h6"
                        fontSize={DEFAULT_FONTSIZE}
                        alignSelf={"center"}
                        paddingLeft={"5px"}
                      >
                        {it?.transactionId || "-"}
                      </Text>
                    </Flex>
                  </OutlineCard>
                );
              })}
            </Paper>
          </OutlineCard>
        </Flex>
      </Flex>
    </>
  );
};

export default PatientDetailsSideSection;

// Superseded by getPaymentModeLabel (patient-payments-constant), which is the
// single source of truth and also covers Cheque / Apply credit balance / ACH —
// those fell through this map and rendered as "-".
// const paymentMethodMapper: Record<string, string> = {
//   ONLINE: "Online",
//   CASH: "Cash",
//   BANK: "Bank",
// };
